// src/helpers/fixedFieldRenderers.js
/* eslint-disable */

import React from "react";
import {
  TextField,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ReactSelect from "react-select";
import GridItem from "components/Grid/GridItem";
import { getAltLabel } from "utils/getAltLabel";

/*──────────────────────────────────────────────────────────────────────┤
  P R O P S   E N T R E G U E S   P E L O   F O R M
  • formData          ← todos os valores do formulário
  • handleChange      ← função genérica p/ setFormData
  • errors            ← dicionário c/ mensagens de erro
  • classes           ← JSS injection p/ manter styling
  • t                 ← i18next
  • branches, workfronts, userOptions ← listas que alguns campos usam
───────────────────────────────────────────────────────────────────────*/

/*=====================================================================*/
/*  Ⅰ.  CAMPOS  “IDENTIFICATION”                                       */
/*=====================================================================*/
const InitiativeId = ({ formData, handleChange, classes, t }) => (
  <GridItem xs={12} sm={2} style={{ marginBottom: 8 }}>
    <TextField
      fullWidth
      label={t("new_initiatives.fields.initiative_id")}
      name="initiativeId"
      value={formData.initiativeId}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

const InitiativeName = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userDetails,
}) => (
  <GridItem xs={12} sm={10} style={{ marginBottom: 8 }}>
    <TextField
      fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_name", userDetails, t)}
      name="initiativeName"
      value={formData.initiativeName}
      error={!!errors.initiativeName}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

/* ---- Branch ------------------------------------------------------- */
const BranchSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  branches,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.branch", userDetails, t)}
      name="branch"
      value={formData.branch}
      error={!!errors.branch}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      {branches.map((b) => (
        <MenuItem key={b.name} value={b.name}>
          {b.name}
        </MenuItem>
      ))}
    </TextField>
    {formData.branch &&
      branches.find((b) => b.name === formData.branch)?.leader && (
        <Typography variant="body2" className={classes.labelLeaders}>
          {`${t("new_initiatives.fields.branch_leader")}: ${
            branches.find((b) => b.name === formData.branch).leader
          }`}
        </Typography>
      )}
  </GridItem>
);

/* ---- Workfront ---------------------------------------------------- */
const WorkfrontSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  workfronts,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.workfront", userDetails, t)}
      name="workfront"
      value={formData.workfront}
      error={!!errors.workfront}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      {workfronts.map((wf) => (
        <MenuItem key={wf.name} value={wf.name}>
          {wf.name}
        </MenuItem>
      ))}
    </TextField>
    {formData.workfront &&
      workfronts.find((w) => w.name === formData.workfront)?.leader && (
        <Typography variant="body2" className={classes.labelLeaders}>
          {`${t("new_initiatives.fields.workfront_leader")}: ${
            workfronts.find((w) => w.name === formData.workfront)?.leader ||
            ""
          }`}
        </Typography>
      )}
  </GridItem>
);

/* ---- Leader & PMO  (ambos usam a mesma lista) --------------------- */
const InitiativeLeaderSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userOptions,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 8 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_leader", userDetails, t)}
      name="initiativeLeader"
      value={formData.initiativeLeader}
      error={!!errors.initiativeLeader}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      <MenuItem key="empty" value="">
        {t("new_initiatives.fields.no_leader_selected", "-- Sem líder selecionado --")}
      </MenuItem>
      {userOptions.map((u) => (
        <MenuItem key={u.value} value={u.value}>
          {u.label}
        </MenuItem>
      ))}
    </TextField>
  </GridItem>
);

const InitiativeLeader2Select = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userOptions,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 8 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_leader_2", userDetails, t)}
      name="initiativeLeader2"
      value={formData.initiativeLeader2}
      error={!!errors.initiativeLeader2}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      <MenuItem key="empty" value="">
        {t("new_initiatives.fields.no_leader_selected", "-- Sem líder selecionado --")}
      </MenuItem>
      {userOptions.map((u) => (
        <MenuItem key={u.value} value={u.value}>
          {u.label}
        </MenuItem>
      ))}
    </TextField>
  </GridItem>
);

const InitiativePmoSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userOptions,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_pmo", userDetails, t)}
      name="initiativePmo"
      value={formData.initiativePmo}
      error={!!errors.initiativePmo}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      <MenuItem key="empty" value="">
        {t("new_initiatives.fields.no_pmo_selected", "-- Sem PMO selecionado --")}
      </MenuItem>
      {userOptions.map((u) => (
        <MenuItem key={u.value} value={u.value}>
          {u.label}
        </MenuItem>
      ))}
    </TextField>
  </GridItem>
);

const IntegrationOwnerSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userOptions,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.integration_owner", userDetails, t)}
      name="integrationOwner"
      value={formData.integrationOwner}
      error={!!errors.integrationOwner}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      <MenuItem key="empty" value="">
        {t("new_initiatives.fields.no_integration_owner_selected", "-- Sem Integration Owner selecionado --")}
      </MenuItem>
      {userOptions.map((u) => (
        <MenuItem key={u.value} value={u.value}>
          {u.label}
        </MenuItem>
      ))}
    </TextField>
  </GridItem>
);

const SponsorSelect = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
  userOptions,
  userDetails,
}) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      select
      fullWidth
      label={getAltLabel("new_initiatives.fields.sponsor", userDetails, t)}
      name="sponsor"
      value={formData.sponsor}
      error={!!errors.sponsor}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    >
      <MenuItem key="empty" value="">
        {t("new_initiatives.fields.no_sponsor_selected", "-- Sem Sponsor selecionado --")}
      </MenuItem>
      {userOptions.map((u) => (
        <MenuItem key={u.value} value={u.value}>
          {u.label}
        </MenuItem>
      ))}
    </TextField>
  </GridItem>
);

/*=====================================================================*/
/*  Ⅱ.  CAMPOS  “DATES”                                                */
/*=====================================================================*/
const ImpStartDate = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={3} style={{ marginBottom: 10 }}>
    <TextField
      type="date"
      label={t("new_initiatives.fields.imp_start_date")}
      name="impStartDate"
      value={formData.impStartDate}
      error={!!errors.impStartDate}
      helperText={errors.impStartDate || ""}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
      style={{ width: "100%" }}
    />
  </GridItem>
);

const ImpEndDate = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={3} style={{ marginBottom: 10 }}>
    <TextField
      type="date"
      label={t("new_initiatives.fields.imp_end_date")}
      name="impEndDate"
      value={formData.impEndDate}
      error={!!errors.impEndDate}
      helperText={errors.impEndDate || ""}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
      style={{ width: "100%" }}
    />
  </GridItem>
);

const ResultsStartDate = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={3} style={{ marginBottom: 10 }}>
    <TextField
      type="date"
      label={t("new_initiatives.fields.results_start_date")}
      name="resultsStartDate"
      value={formData.resultsStartDate}
      error={!!errors.resultsStartDate}
      helperText={errors.resultsStartDate || ""}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
      style={{ width: "100%" }}
    />
  </GridItem>
);

const ResultsEndDate = ({
  formData,
  handleChange,
  errors,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={3} style={{ marginBottom: 10 }}>
    <TextField
      type="date"
      label={t("new_initiatives.fields.results_end_date")}
      name="resultsEndDate"
      value={formData.resultsEndDate}
      error={!!errors.resultsEndDate}
      helperText={errors.resultsEndDate || ""}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
      style={{ width: "100%" }}
    />
  </GridItem>
);

/*=====================================================================*/
/*  Ⅲ.  CAMPOS  “DESCRIPTION” & “RISKS”                                */
/*=====================================================================*/
const DescriptionField = ({
  formData,
  handleChange,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={12} style={{ marginBottom: 10 }}>
    <TextField
      fullWidth
      multiline
      rows={4}
      label={t("new_initiatives.fields.description")}
      name="description"
      value={formData.description}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
    />
  </GridItem>
);

const RisksField = ({
  formData,
  handleChange,
  classes,
  t,
}) => (
  <GridItem xs={12} sm={12} style={{ marginBottom: 10 }}>
    <TextField
      fullWidth
      multiline
      rows={4}
      label={t("new_initiatives.fields.risks")}
      name="risks"
      value={formData.risks}
      onChange={handleChange}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
    />
  </GridItem>
);

/* ---- ACCESS GROUPS (multi-select) -------------------------------- */
const AccessGroupsField = ({
  accessOptions,
  selectedAccessGroups,
  setSelectedAccessGroups,
  classes,
  customStyles,
  t,
  errors,
}) => (
  <GridItem xs={12} md={6}>
    <div className={classes.multiSelectContainer}>
      <label className={classes.labelMultiSelect}>
        {t("new_initiatives.fields.access_group")}
        {errors.accessGroup && (
          <span style={{ color: "red", fontSize: 12 }}> {errors.accessGroup}</span>
        )}
      </label>
      <ReactSelect
        isMulti
        options={accessOptions}
        value={selectedAccessGroups}
        onChange={setSelectedAccessGroups}
        styles={customStyles}
        placeholder={t("new_initiatives.fields.select_label")}
        closeMenuOnSelect={false}
      />
    </div>
  </GridItem>
);

/* ---- TAGS (multi-select) ----------------------------------------- */
const TagsField = ({
  tagOptions,
  selectedTags,
  setSelectedTags,
  classes,
  customStyles,
  t,
  userDetails,
}) => (
  <GridItem xs={12} md={6}>
    <div className={classes.multiSelectContainer}>
      <label className={classes.labelMultiSelect}>
        {getAltLabel("new_initiatives.fields.tags", userDetails, t)}
      </label>
      <ReactSelect
        isMulti
        options={tagOptions}
        value={selectedTags}
        onChange={setSelectedTags}
        styles={customStyles}
        placeholder={t("new_initiatives.fields.select_label")}
        closeMenuOnSelect={false}
      />
    </div>
  </GridItem>
);


const ImpactField = ({
  impactOptions,
  selectedImpact,
  setSelectedImpact,
  classes,
  customStyles,
  t,
}) => (
  <GridItem xs={12} md={6}>
    <div className={classes.multiSelectContainer}>
      <label
        className={classes.labelMultiSelect}
        style={{ marginBottom: 8 }}
      >
        {t("new_initiatives.fields.initiative_impact")}
      </label>
      <ReactSelect
        isMulti
        options={impactOptions}
        value={selectedImpact}
        onChange={setSelectedImpact}
        styles={customStyles}
        placeholder={t("new_initiatives.fields.select_label")}
        closeMenuOnSelect={false}
      />
    </div>
  </GridItem>
);

const buildEditorsField = (roleId, labelKey) =>
  function EditorsField({
    userOptions,
    value,
    setter,
    classes,
    customStyles,
    t,
  }) {
    /* `value` e `setter` são injetados pelo form */
    return (
      <GridItem xs={12} md={6}>
        <div className={classes.multiSelectContainer}>
          <label className={classes.labelMultiSelect}>
            {t(`new_initiatives.fields.${labelKey}`)}
          </label>
          <ReactSelect
            isMulti
            options={userOptions}
            value={value}
            onChange={setter}
            styles={customStyles}
            placeholder={t("new_initiatives.fields.select_label")}
            closeMenuOnSelect={false}
          />
        </div>
      </GridItem>
    );
  };

/* 3 instâncias específicas ------------------------------------------ */
const EditorsOnePageField  = buildEditorsField("one_page", "editors_one_page");
const EditorsImpField      = buildEditorsField("implementation", "editors_imp");
const EditorsResultsField  = buildEditorsField("results", "editors_results");




/*=====================================================================*/
/*  E X P O R T A   O   “ R E G I S T R Y ”                            */
/*=====================================================================*/
export const fixedFieldRenderers = {
  /* Identificação */
  initiativeId: InitiativeId,
  initiativeName: InitiativeName,
  branch: BranchSelect,
  workfront: WorkfrontSelect,
  initiativeLeader: InitiativeLeaderSelect,
  initiativeLeader2: InitiativeLeader2Select,
  initiativePmo: InitiativePmoSelect,
  integrationOwner: IntegrationOwnerSelect,
  sponsor: SponsorSelect,
  tags: TagsField,
  accessGroup: AccessGroupsField,
  initiativeImpact: ImpactField,

  /* Editores */
  editors_one_page: EditorsOnePageField,
  editors_implementation: EditorsImpField,
  editors_results: EditorsResultsField,

  /* Datas */
  impStartDate: ImpStartDate,
  impEndDate: ImpEndDate,
  resultsStartDate: ResultsStartDate,
  resultsEndDate: ResultsEndDate,

  /* Descrição & Riscos */
  description: DescriptionField,
  risks: RisksField,
};
